import { useEffect, useState, type ReactNode } from 'react';
import { ConfirmDialog } from '@/shared/ui/Modal';
import { Input } from '@/shared/ui/Input';
import styles from './TextRequests.module.css';

/** Bulk deletes cannot be undone: the button stays off until the word DELETE is typed. */
export function TypeDeleteDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  isLoading,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  children: ReactNode;
  isLoading?: boolean;
}) {
  const [typed, setTyped] = useState('');
  useEffect(() => {
    if (!isOpen) setTyped('');
  }, [isOpen]);
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={
        <div className={styles.typeDelete}>
          {children}
          <Input
            label="Type DELETE to confirm"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            autoComplete="off"
            autoFocus
          />
        </div>
      }
      confirmLabel="Delete"
      variant="destructive"
      isLoading={isLoading}
      confirmDisabled={typed.trim() !== 'DELETE'}
    />
  );
}
